"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactive_google_map_1 = require("@dotdev/reactive-google-map");
var __1 = require("../");
/** [[include:component/click-and-collect-search.md]] */
var ClickAndCollectSearch = /** @class */ (function (_super) {
    __extends(ClickAndCollectSearch, _super);
    function ClickAndCollectSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: "",
        };
        _this.handleSelect = function (place) {
            if (!_this.props.autocomplete) {
                return;
            }
            var position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            if (_this.context.clickAndCollect.googleMapClient) {
                _this.context.clickAndCollect.googleMapClient.mapPanTo(position);
            }
            if (_this.props.onSelect) {
                _this.props.onSelect(place);
            }
            _this.context.clickAndCollect.updateQuery({
                position: position,
            });
        };
        _this.handleChange = function (event) {
            if (_this.props.autocomplete) {
                return;
            }
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
            _this.setState({
                value: event.target.value,
            });
            _this.context.clickAndCollect.updateQuery({
                search: event.target.value,
            });
        };
        _this.renderAutocompleteInput = function (props) { return (React.createElement(reactive_google_map_1.GoogleMapAutocomplete, __assign({ googleMapsApiVersion: _this.context.clickAndCollect.options.googleMapsApiVersion, googleMapsApiKey: _this.context.clickAndCollect.options.googleMapsApiKey, callback: _this.context.clickAndCollect.setGoogleMapAutocompleteClient, onSelect: _this.handleSelect }, props))); };
        _this.renderTextInput = function (props) { return (React.createElement("input", { style: props.style, className: props.className, placeholder: props.placeholder, value: _this.state.value, onChange: _this.handleChange })); };
        return _this;
    }
    ClickAndCollectSearch.prototype.render = function () {
        if (this.props.autocomplete) {
            return this.renderAutocompleteInput(this.props);
        }
        return this.renderTextInput(this.props);
    };
    ClickAndCollectSearch.contextType = __1.Context;
    return ClickAndCollectSearch;
}(React.Component));
exports.ClickAndCollectSearch = ClickAndCollectSearch;
//# sourceMappingURL=click-and-collect-search.js.map